import { render, staticRenderFns } from "./jobtj.vue?vue&type=template&id=f1388af6&scoped=true&"
import script from "./jobtj.vue?vue&type=script&lang=js&"
export * from "./jobtj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1388af6",
  null
  
)

export default component.exports